<div
  class="gw-box-border gw-flex gw-h-screen gw-max-h-screen gw-min-h-0 gw-flex-col gw-overflow-hidden gw-bg-background-base"
>
  <div
    *ngIf="!hasSidePanel"
    class="gw-shrink-0 gw-hidden md:gw-flex gw-justify-end gw-p-medium"
  >
    <app-language-selector></app-language-selector>
  </div>

  <main
    class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-overflow-hidden md:gw-flex-row"
  >
    <!-- Left: brand side panel (desktop only when image configured) -->
    <section
      *ngIf="hasSidePanel"
      class="gw-relative gw-hidden gw-h-full gw-min-h-0 gw-overflow-hidden gw-bg-background-base md:gw-flex md:gw-w-1/2 md:gw-flex-none md:gw-items-center md:gw-justify-center lg:gw-max-w-[960px] lg:gw-w-3/5 gw-p-medium md:gw-p-2x-large [@media(max-height:720px)]:md:gw-p-large"
    >
      <!-- Background art: full-bleed cover + scrims -->
      <div
        class="gw-pointer-events-none gw-absolute gw-inset-0 gw-z-0 gw-overflow-hidden"
        aria-hidden="true"
      >
        <div class="gw-absolute gw-inset-0 gw-bg-background-base"></div>
        <div class="gw-absolute gw-inset-0 gw-overflow-hidden">
          <img
            [src]="branding?.login?.sidePanel?.backgroundImage"
            [attr.alt]="'features.loginPage.sidePanelBackgroundAlt' | translate"
            [attr.title]="
              'features.loginPage.sidePanelImageRecommendation' | translate
            "
            width="1080"
            height="1440"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
            class="gw-h-full gw-min-h-full gw-w-full gw-object-cover gw-object-center gw-saturate-[1.02]"
          />
        </div>
        <!-- Softer toward top-left so photography stays visible; heavier bottom / outer edges -->
        <div
          class="gw-absolute gw-inset-0 gw-bg-[linear-gradient(155deg,rgba(0,0,0,0.38)_0%,rgba(0,0,0,0.18)_42%,rgba(0,0,0,0.06)_78%,transparent_100%)]"
        ></div>
        <div
          class="gw-absolute gw-inset-0 gw-bg-[linear-gradient(to_top,rgba(0,0,0,0.36)_0%,transparent_52%)]"
        ></div>
        <div
          class="gw-absolute gw-inset-0 gw-bg-[radial-gradient(ellipse_120%_100%_at_50%_45%,transparent_42%,rgba(0,0,0,0.14)_100%)]"
        ></div>
        <div
          class="gw-absolute gw-inset-0 gw-bg-gradient-to-br gw-from-brand-primary/8 gw-via-transparent gw-to-transparent"
        ></div>
      </div>

      <div
        class="gw-relative gw-z-20 gw-isolate gw-w-full gw-max-w-4xl gw-shrink-0"
      >
        <!-- Readable surface; headline is innerHTML — only rhythm, no forced gw-text-* / scale -->
        <div
          class="gw-rounded-[2rem] gw-border gw-border-border-soft gw-bg-background-base gw-p-large gw-shadow-lg gw-backdrop-blur-md md:gw-p-2x-large xl:gw-p-4x-large [@media(max-height:720px)]:md:gw-p-large"
        >
          <div
            class="gw-mb-2x-large md:gw-mb-4x-large [@media(max-height:720px)]:md:gw-mb-2x-large"
          >
            <img
              [src]="style.logo"
              alt=""
              class="gw-max-h-12 gw-object-contain"
            />
          </div>

          <h1
            *ngIf="loginSidePanelHeadlineHtml"
            class="gw-mb-large md:gw-mb-2x-large [@media(max-height:720px)]:md:gw-mb-large"
            [innerHTML]="loginSidePanelHeadlineHtml"
          ></h1>

          <p
            *ngIf="branding?.login?.sidePanel?.subheadline"
            class="gw-mb-large gw-max-w-2xl gw-text-xl gw-leading-relaxed gw-text-text-secondary md:gw-mb-2x-large md:gw-text-2xl [@media(max-height:720px)]:md:gw-mb-large"
          >
            {{ branding?.login?.sidePanel?.subheadline }}
          </p>

          <div
            *ngIf="branding?.login?.sidePanel?.stats?.length"
            class="gw-grid gw-grid-cols-2 gw-gap-x-large gw-border-t gw-border-border-soft gw-pt-x-large md:gw-gap-3x-large md:gw-pt-3x-large [@media(max-height:720px)]:md:gw-gap-x-large [@media(max-height:720px)]:md:gw-pt-x-large"
          >
            <div *ngFor="let stat of branding?.login?.sidePanel?.stats">
              <div
                class="gw-text-3xl gw-font-bold gw-text-text-primary md:gw-text-4xl"
              >
                {{ stat.value }}
              </div>
              <div
                class="gw-mt-2 gw-text-sm gw-font-medium gw-uppercase gw-tracking-widest gw-text-text-tertiary"
              >
                {{ stat.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Right: login form -->
    <section
      class="gw-relative gw-flex gw-h-full gw-min-h-0 gw-flex-1 gw-flex-col gw-overflow-hidden gw-bg-background-base"
    >
      <div
        *ngIf="hasSidePanel"
        class="gw-absolute gw-right-0 gw-top-0 gw-z-10 gw-hidden gw-p-medium md:gw-flex"
      >
        <app-language-selector></app-language-selector>
      </div>

      <div
        class="gw-flex gw-shrink-0 gw-items-center gw-justify-between gw-border-b gw-border-border-soft gw-p-medium md:gw-hidden"
      >
        <img [src]="style.logo" alt="" class="gw-max-h-10 gw-object-contain" />
        <app-language-selector></app-language-selector>
      </div>

      <div
        class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-overflow-hidden gw-px-medium gw-py-medium md:gw-px-large md:gw-py-2x-large lg:gw-px-3x-large [@media(max-height:720px)]:md:gw-py-small [@media(max-height:720px)]:lg:gw-py-small"
      >
        <div
          class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-overflow-y-auto gw-overflow-x-hidden md:gw-items-center [@media(max-height:720px)]:md:gw-items-stretch"
        >
          <div
            class="gw-mx-auto gw-flex gw-w-full gw-max-w-md gw-flex-col gw-py-0 md:gw-py-medium md:gw-my-auto [@media(max-height:720px)]:md:gw-my-0 [@media(max-height:720px)]:md:gw-py-0"
          >
            <div
              *ngIf="!hasSidePanel"
              class="gw-mb-medium gw-hidden gw-justify-center md:gw-mb-2x-large md:gw-flex [@media(max-height:720px)]:md:gw-mb-medium"
            >
              <img
                [src]="style.logo"
                alt=""
                class="gw-max-h-12 gw-object-contain"
              />
            </div>

            <div
              class="gw-mb-medium md:gw-mb-2x-large [@media(max-height:720px)]:md:gw-mb-small [@media(max-height:720px)]:lg:gw-mb-x-small"
            >
              <h2
                class="gw-mb-x-small gw-text-xl gw-font-bold gw-tracking-tight gw-text-text-primary md:gw-mb-small md:gw-text-2xl lg:gw-text-3xl [@media(max-height:720px)]:md:gw-text-xl [@media(max-height:720px)]:lg:gw-text-2xl"
              >
                {{ 'features.loginPage.loginTitle' | translate }}
              </h2>
              <p class="gw-text-sm gw-text-text-secondary">
                {{ 'features.loginPage.welcomeBackDescription' | translate }}
              </p>
            </div>

            <form
              (ngSubmit)="login()"
              class="gw-flex gw-flex-col gw-gap-x-large md:gw-gap-2x-large [@media(max-height:720px)]:md:gw-gap-medium [@media(max-height:720px)]:lg:gw-gap-medium"
            >
              <gatewee-input-v2
                id="login-email"
                type="email"
                [label]="'features.loginPage.form.emailLabel' | translate"
                [placeholder]="'features.loginPage.form.emailLabel' | translate"
                [value]="email"
                (valueChange)="onEmailChange($event)"
                [required]="true"
                [iconName]="'@tui.mail'"
              ></gatewee-input-v2>

              <gatewee-input-v2
                id="login-password"
                type="password"
                type="password"
                [label]="'features.loginPage.form.passwordLabel' | translate"
                [placeholder]="
                  'features.loginPage.form.passwordLabel' | translate
                "
                [value]="password"
                (valueChange)="onPasswordChange($event)"
                [required]="true"
                [iconName]="'@tui.lock'"
              ></gatewee-input-v2>

              <div class="gw-flex gw-flex-col gw-items-center gw-gap-medium">
                <a
                  routerLink="/password-reset-request"
                  class="gw-self-end gw-text-sm gw-font-medium gw-text-text-action hover:gw-underline"
                >
                  {{ 'features.loginPage.form.forgotPassword' | translate }}
                </a>
                <gatewee-button
                  variant="primary"
                  [title]="'features.loginPage.form.signInButton' | translate"
                  type="submit"
                  class="gw-w-full"
                ></gatewee-button>
              </div>
            </form>

            <div
              *ngIf="showSignupButton"
              class="gw-mt-large gw-flex gw-flex-wrap gw-items-center gw-justify-center gw-gap-small gw-border-t gw-border-border-soft gw-pt-large gw-text-center md:gw-mt-2x-large md:gw-pt-2x-large [@media(max-height:720px)]:md:gw-mt-x-small [@media(max-height:720px)]:md:gw-pt-x-small [@media(max-height:720px)]:lg:gw-mt-small [@media(max-height:720px)]:lg:gw-pt-small"
            >
              <span class="gw-text-sm gw-text-text-secondary">
                {{ 'features.loginPage.joinUsQuestion' | translate }}
              </span>
              <a
                routerLink="/onboarding"
                class="gw-text-sm gw-font-medium gw-text-text-action hover:gw-underline"
              >
                {{ 'features.loginPage.joinUsLink' | translate }}
              </a>
            </div>

            <div
              *ngIf="hasMobileApp"
              class="gw-mt-large gw-flex gw-flex-col gw-items-center gw-gap-medium gw-pt-large md:gw-mt-2x-large md:gw-gap-large md:gw-pt-2x-large [@media(max-height:720px)]:md:gw-mt-large [@media(max-height:720px)]:md:gw-gap-medium [@media(max-height:720px)]:md:gw-pt-large [@media(max-height:720px)]:lg:gw-hidden"
            >
              <span
                class="gw-text-[10px] gw-font-semibold gw-uppercase gw-tracking-[0.2em] gw-text-text-tertiary"
              >
                {{ 'features.loginPage.downloadApp' | translate }}
              </span>
              <div class="gw-flex gw-flex-wrap gw-justify-center gw-gap-medium">
                <a
                  *ngIf="hasAppStore"
                  [href]="branding?.login?.mobileApp?.appStoreUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="gw-flex gw-items-center gw-gap-small gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-px-large gw-py-medium gw-transition-colors hover:gw-bg-background-elevation-3"
                >
                  <svg
                    class="gw-h-5 gw-w-5 gw-fill-text-secondary gw-transition-colors hover:gw-fill-text-primary"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C4.22 16.5 4.54 10.4 8.2 10.05c1.1-.1 1.9.46 2.58.46.68 0 1.74-.63 3.03-.5 1.12.1 2.22.58 2.87 1.43-2.3 1.4-1.92 4.67.43 5.64-.48 1.25-1.08 2.3-2.06 3.2zM12.03 9.42c-.08-2.3 1.9-4.27 4.1-4.33.2 2.56-2.05 4.5-4.1 4.33z"
                    />
                  </svg>
                  <div
                    class="gw-flex gw-flex-col gw-items-start gw-leading-none"
                  >
                    <span
                      class="gw-text-[8px] gw-uppercase gw-tracking-wider gw-text-text-tertiary"
                    >
                      {{ 'features.loginPage.appStoreCaption' | translate }}
                    </span>
                    <span class="gw-text-xs gw-font-bold gw-text-text-primary">
                      App Store
                    </span>
                  </div>
                </a>
                <a
                  *ngIf="hasGooglePlay"
                  [href]="branding?.login?.mobileApp?.googlePlayUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="gw-flex gw-items-center gw-gap-small gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-px-large gw-py-medium gw-transition-colors hover:gw-bg-background-elevation-3"
                >
                  <svg
                    class="gw-h-5 gw-w-5 gw-fill-text-secondary gw-transition-colors hover:gw-fill-text-primary"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      d="M5 3.31c-.06.18-.1.38-.1.59v16.2c0 .21.04.41.1.59l9.11-9.11L5 3.31zM15.5 11.59l3.05-1.76c.74-.43.74-1.12 0-1.55L15.5 6.52l-1.39 1.39 1.39 3.68zM5.7 3l8.41 4.86 1.39-1.39L5.7 3zM5.7 21l9.8-5.65-1.39-1.39L5.7 21z"
                    />
                  </svg>
                  <div
                    class="gw-flex gw-flex-col gw-items-start gw-leading-none"
                  >
                    <span
                      class="gw-text-[8px] gw-uppercase gw-tracking-wider gw-text-text-tertiary"
                    >
                      {{ 'features.loginPage.googlePlayCaption' | translate }}
                    </span>
                    <span class="gw-text-xs gw-font-bold gw-text-text-primary">
                      Google Play
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-links class="gw-shrink-0"></app-links>
    </section>
  </main>
</div>
